module.exports = __webpack_public_path__ + "static/media/FORMATO CARTA DE MOTIVACION CON EXPERIENCIA.4958817d.docx";